module.exports = __webpack_public_path__ + "img/logo-jolahr-large.0d6eb591.svg";